import {gql} from '@apollo/client';

export default gql`
    fragment Image on Image {
        id
        height
        width
        secret {
            crop
            expires
            key
            path
            prefix
        }
    }
`;
